import { useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { selectIsOffline } from '~/agent/store/agent.selectors'
import usePreContract from '~/contract/components/PreContract/usePreContract'
import { selectLines } from '~/line/store/line.selectors'
import { selectContractDestination } from '~/payments/store/payments.selectors'
import { selectIsPostpaid, selectIsCustomerValid } from '~/sale/store/sale.selectors'

export default function useSummaryPage() {
  const [isLegalOpen, setIsLegalOpen] = useState(false)
  const [shouldCreatePreContract, setShouldCreatePreContract] = useState(false)
  const lines = useSelector(selectLines)
  const isOffline = useSelector(selectIsOffline)
  const isPostpaid = useSelector(selectIsPostpaid)
  const canContinue = useSelector(selectIsCustomerValid)
  const contractDestination = useSelector(selectContractDestination)
  const title = useMemo(() => (isPostpaid ? 'Línea Pospago' : 'Línea Prepago'), [isPostpaid])
  const history = useHistory()

  usePreContract(shouldCreatePreContract)

  const enabled = useMemo(() => {
    return canContinue && (isPostpaid ? !!contractDestination : true)
  }, [canContinue, contractDestination, isPostpaid])

  function onConfirmLegal() {
    setIsLegalOpen(false)
    setShouldCreatePreContract(true)
  }

  return {
    lines,
    title,
    isOffline,
    isPostpaid,
    enabled,
    setShouldCreatePreContract,
    setIsLegalOpen,
    isLegalOpen,
    onConfirmLegal,
    history,
  }
}
